import React from "react";
import _ from "lodash";
import MyLeagues from "../leagues/MyLeagues";


const MyWSLLeagues = ({ route }) => {
  return (<>
    <div className="container my-3">
        <h1>WSL Mini Leagues</h1>
        <p>This is where you will be able to manage your mini-leagues, to play against your
          friends, family, and work colleagues! Once you have selected your fantasy team, you may
					join existing leagues or create your own!
      </p>
      
	  <MyLeagues route={route} competition="wsl" />
    
    </div>
<div className="container">
<p>Want to find public mini-leagues to test your fantasyWSL team against? Or want to learn about
some of the organisations that are doing great work to help grow women's football in the UK? 
	  Then check out the open mini-leagues
from some of our friends below!</p>

      <table className="table table-striped">
        <thead className="thead-dark">
<tr>
<th scope="col"></th>
<th scope="col">Name</th>
<th scope="col">Code</th>
<th scope="col"></th>
</tr>
</thead>

<tbody>
<tr>
<td><img hspace="20" src="/img/logo-round.png" width="40"/></td>
<td>ShePlays</td>
<td>sheplays</td>
<td>Compete against the ShePlays admin team</td>
</tr>
<tr>
<td><img hspace="20" src="/img/gotb2.jpg" width="40"/></td>
<td>Girls on the Ball</td>
<td>GOTB</td>
<td>Online platform promoting UK + Irish women's football.</td>
</tr>
<tr>
<td><img hspace="20" src="/img/FFH-Logo.PNG" width="40"/></td>
<td>Fantasy Football Hub</td>
<td>FFH</td>
<td>Fantasy Football Hub is purpose-built to turn fantasy managers into fantasy winners, using their industry leading AI. FFH is expanding their offering of fantasy games to Women's football and so partnering with She Plays was essential!</td>
</tr>
<tr>
<td><img hspace="20" src="/img/tgtbsmall.jpg" width="40"/></td>
<td>Two Girls Talk Ball</td>
<td>TGTB</td>
<td>The alternative take on Women's Football // podcast hosted by @cfrench09 and @connor_tamsin!</td>
</tr>
<tr>
<td><img hspace="20" src="/img/stbsmall.jpg" width="40"/></td>
<td>She Talks Ball</td>
<td>STB</td>
<td>Women's sports content, coverage & conversation | run by @radhalathgupta.</td>
</tr>
<tr>
<td><img hspace="20" src="/img/HYT23.jpg" width="40"/></td>
<td>How's Your Fantasy Football?</td>
<td>HYT</td>
<td>Compete for a chance to win a pack of our 22/23 collectable cards!</td>
</tr>
<tr>
<td><img hspace="20" src="/img/wososhow.png" width="40"/></td>
<td>The Women's Soccer Show</td>
<td>thewososhow</td>
<td>Official Mini-League of award-winning Women's Football Podcast 'The Women's Soccer Show'</td>
</tr>
<tr>
<td><img hspace="20" src="/img/LILYS_white_logo_color_pink_background.jpg" width="40"/></td>
<td>Lily's League</td>
<td>lilys2324</td>
<td>Lily's League has been set up for queer womxn football supporters. It is part of Lily's Cafe and Bar - a queer womxn space which is inclusive of and supported by the lovely LGBTQ+ community and their amazing allies.</td>
</tr>
<tr>
<td><img hspace="20" src="/img/NYAEF.jpg" width="40"/></td>
<td>Not Your Average England Fan</td>
<td>texee</td>
<td>Notyouraveragenglandfan.com is not just for disabled or expat or 'minority' fans — every England fan is Not Your Average England Fan</td>
</tr>
<tr>
<td><img hspace="20" src="/img/AWSC.jpg" width="40"/></td>
<td>Arsenal Women Supporters Club</td>
<td>Arsenal</td>
<td>Official supporters club of Arsenal Women</td>
</tr>
<tr>
<td><img hspace="20" src="/img/CWSG.jpg" width="40"/></td>
<td>Chelsea Women Supporters Group</td>
<td>CWSG</td>
<td>Home of Chelsea Women Supporters Group</td>
</tr>
<tr>
<td><img hspace="20" src="/img/mcwfc1.jpg" width="40"/></td>
<td>MCWFC Official Supporters Club</td>
<td>MCWFCOSC</td>
<td>Official supporters club of Manchester City Women</td>
</tr>
<tr>
<td><img hspace="20" src="/img/muwsc.jpg" width="40"/></td>
<td>MUWSC Fantasy League</td>
<td>MUWSC</td>
<td>Manchester United Women Supporters Club.</td>
</tr>
<tr>
<td><img hspace="20" src="/img/wsl/badges/ast.png" width="40"/></td>
<td>Aston Villa Fans</td>
<td>AVWFC</td>
<td>Mini-league for Aston Villa fans</td>
</tr>
<tr>
<td><img hspace="20" src="/img/wsl/badges/brh.png" width="40"/></td>
<td>Brighton & Hove Albion Fans</td>
<td>BHAFC</td>
<td>Mini-league for Brighton & Hove Albion fans</td>
</tr>
<tr>
<td><img hspace="20" src="/img/wsl/badges/bsc.png" width="40"/></td>
<td>Bristol City Fans</td>
<td>BCWFC</td>
<td>Mini-league for Bristol City fans</td>
</tr>
<tr>
<td><img hspace="20" src="/img/wsl/badges/eve.png" width="40"/></td>
<td>Everton Fans</td>
<td>COYB</td>
<td>Mini-league for Everton fans</td>
</tr>
<tr>
<td><img hspace="20" src="/img/wsl/badges/lei.png" width="40"/></td>
<td>Leicester City Fans</td>
<td>LCFCW</td>
<td>Mini-league for Leicester City fans</td>
</tr>
<tr>
<td><img hspace="20" src="/img/wsl/badges/liv.png" width="40"/></td>
<td>Liverpool Fans</td>
<td>YNWA</td>
<td>Mini-league for Liverpool fans</td>
</tr>
<tr>
<td><img hspace="20" src="/img/wsl/badges/tot.png" width="40"/></td>
<td>Tottenham Fans</td>
<td>Spurs</td>
<td>Mini-league for Tottenham fans</td>
</tr>
<tr>
<td><img hspace="20" src="/img/wsl/badges/whu.png" width="40"/></td>
<td>West Ham Fans</td>
<td>WHU</td>
<td>Mini-league for West Ham fans</td>
</tr>
</tbody>
</table> 
</div>

 </> );
};




export default MyWSLLeagues;


